import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox/checkbox';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AccountListMapperI } from '../../models/account-list/account-list';
import * as moment from 'moment';


@Component({
  selector: 'anterasoftware-kanban-account-list-view',
  templateUrl: './kanban-account-list-view.component.html',
  styleUrls: ['./kanban-account-list-view.component.scss']
})
export class KanbanAccountListViewComponent implements OnInit {
  @ViewChild(MatSort) public sort: MatSort = {} as MatSort;

  @Input() public listDataSource: any[] = [];
  @Input() public displayedColumns: string[] = [];
  @Input() public pageSizeOptions: number[] = [];
  @Input() public tableLength: number = 0;
  @Input() public page: string = '';
  @Input() public displayActionsBar: boolean = false;
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';
  @Input() public mappingFields: any[] = [];

  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onColumnClick: EventEmitter<any> = new EventEmitter();
  @Output() public onPaginateFire: EventEmitter<any> = new EventEmitter();
  @Output() public onSortFired: EventEmitter<any> = new EventEmitter();


  public dataSource: any;
  public selectAll: boolean = false;

  public pageSize: number = 50;

  constructor() {}

  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.listDataSource);
    this.appendColumns();
  }

  public ngOnChanges() {
    this.appendColumns();
    this.dataSource = new MatTableDataSource(this.listDataSource);
  }

  public appendColumns(){
    const standardColumns = ['select']

    standardColumns.forEach((colName) => {
      if(!this.displayedColumns?.includes(colName)){
        this.displayedColumns.unshift(colName);
      }
    });
  }

  /**
   * Toggles, so all checkboxes are selected.
   *
   * @returns {void}
   */
  public toggleAll(selectType: string, checkbox?: MatCheckbox, selectedRow?: AccountListMapperI ): void {

    switch (selectType){
      case 'SINGLE':
        this.dataSource.data.find((row: AccountListMapperI) => row.id === selectedRow?.id).select = checkbox?.checked;
      break;
      case 'FIRST_50':
        // Special scenario need to ask bhavesh how to distinguish all and first 50.
        this.selectAll = true;
        this.dataSource.data.forEach((data: AccountListMapperI) => (data.select = true));
      break;
      case 'SELECT_ALL':
          // Special scenario need to ask bhavesh how to distinguish all and first 50.
         this.selectAll = true;
         this.dataSource.data.forEach((data: AccountListMapperI) => (data.select = true));
      break;
      case 'DESELECT_ALL':
          this.selectAll = false;
          this.dataSource.data.forEach((data: AccountListMapperI) => (data.select = false));
      break;
      case 'SELECT_ALL_TOGGLE':
          this.selectAll = !this.selectAll;
          this.dataSource.data.forEach((data: AccountListMapperI) => (data.select = this.selectAll));
          selectType = this.selectAll ? 'SELECT_ALL' : 'DESELECT_ALL';
      break;
      default:
          this.selectAll = !this.selectAll;
          this.dataSource.data.forEach((data: AccountListMapperI) => (data.select = this.selectAll));
      break;
    }

    this.selectClicked.emit({data: this.dataSource.data, selectType});
  }

  /**
   * On column click, emit the colum name and the row selected.
   *
   * @param {AccountListMapperI} element
   * @param {string} columnName
   * @returns {void}
   */
  public onColumnClicked(element: AccountListMapperI, columnName: string): void {
    this.onColumnClick.emit({ columnName, rowSelected: element });
  }

  /**
   * On paginate emit event;
   *
   * @returns {void}
   */
  public paginate(event: any) {
    const paginateObj = {
      offset: event.pageIndex,
      limit: event.pageSize,
    };

    this.pageSize = event.pageSize;
    this.onPaginateFire.emit(paginateObj);
  }


  /**
   * On material sort fire event.
   *
   * @returns {void}
   */
  public onListViewSort(event: Sort) {
    this.onSortFired.emit(event);
  }

  public getDateFormat(date :any, includeTime = false, excludeTime = false, convert = false){
    if(date == null || date == '' || date == '0000-00-00 00:00:00' || date == '0000-00-00' || date == '0000-00-00' || (String(date).indexOf("0000") > -1 && String(date).indexOf("+0000") < 0 )){
        return '';
    }
    if(convert){
      if(includeTime){
    return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString);
    }
      }          
    }else{
      if(includeTime){
    return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(date).format(this.dateFormatString);
    }
      }      
    }
  }
}


